import styled from 'styled-components';

import Clickable from '#@/components/Clickable';
import { sizes } from '#@/shared/utils/styles';

export const StyledClickable = styled(Clickable)`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${sizes.iconPaddedSize}px;
  height: ${sizes.iconPaddedSize}px;

  &:disabled {
    opacity: 0.2;
  }
`;
